import React, { useState } from "react";
import ReactPlayer from "react-player";

export default ({
  name,
  type,
  backgroundImage,
  onClick,
  videoLink,
  element
}) => {
  const [playing, togglePlaying] = useState(false);

  return (
    <a
      className="project"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        cursor: type === "Photo" ? "default" : "pointer"
        // height: playing && type === "Photo" ? "630px" : null
      }}
      onClick={() => {
        onClick && onClick(playing);
        togglePlaying(!playing);
      }}
    >
      {videoLink && (
        <ReactPlayer
          url={videoLink}
          width="100%"
          height="100%"
          wrapper="video-container"
          playing
          style={{ opacity: playing ? 1 : 0 }}
          playing={playing}
        />
      )}

      <div className="desc">
        <div className="con">
          <h3>
            <a>{name}</a>
          </h3>
          <span>{type}</span>
          <p className="icon">
            {(type === "Photo" && "") ||
              /* <span>
                <a>
                  {playing ? "Shrink" : "Expand"}
                  <i
                    className={`icon-${playing ? "minimize" : "maximize"}`}
                    style={{
                      position: "relative",
                      top: "2px",
                      marginLeft: "4px"
                    }}
                  />
                </a>
              </span> */
              (type === "Audio" && (
                <span>
                  <a>
                    {playing ? "Pause" : "Listen"}
                    <i
                      className={`icon-${playing ? "media-pause" : "volume"}`}
                      style={{
                        position: "relative",
                        top: "2px",
                        marginLeft: "4px"
                      }}
                    />
                  </a>
                </span>
              )) ||
              (type === "Video" && (
                <span>
                  <a>
                    Play
                    <i
                      className={`icon-${
                        playing ? "media-pause" : "media-play"
                      }`}
                      style={{
                        position: "relative",
                        top: "2px",
                        marginLeft: "4px"
                      }}
                    />
                  </a>
                </span>
              ))}
          </p>
        </div>
      </div>
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/components/portfolioItem.js